import KioskModal from "../../components/modals/KioskModal";
import { formatPageList } from "../../utils/pageRange";

// Предупреждение перед подтверждением заказа: в выбранных страницах есть
// пустые (см. preview/pageAnalysis.js). findings — по документу:
// { doc, blankPages, remaining }; remaining пуст, если пустые все выбранные
// страницы — такой документ не урезаем (печатать было бы нечего).
function BlankPagesModal({ findings, onRemove, onKeep, t }) {
    const canRemove = findings.some((finding) => finding.remaining.length > 0);

    return (
        <KioskModal
            tone="warn"
            icon={
                <svg className="w-[5vh] h-[5vh]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
                    <path d="M14 3v5h5M9.5 12.5l5 5M14.5 12.5l-5 5" />
                </svg>
            }
            title={t("editDoc.blank_pages.title")}
            description={t("editDoc.blank_pages.description")}
            footer={
                <div className="flex gap-[1vw]">
                    <button data-analytics="blankpagesmodal.keep.1"
                        type="button"
                        onClick={onKeep}
                        className="flex-1 py-[1.8vh] rounded-full bg-[#F1F3F7] text-[1.8vh] font-bold text-[#12161F] active:bg-[#E1E4EB] transition-colors"
                    >
                        {t("editDoc.blank_pages.keep")}
                    </button>
                    {canRemove && (
                        <button data-analytics="blankpagesmodal.remove.2"
                            type="button"
                            onClick={onRemove}
                            className="flex-1 py-[1.8vh] rounded-full bg-[#246CE2] text-[1.8vh] font-bold text-white active:bg-[#1B55B4] transition-colors"
                        >
                            {t("editDoc.blank_pages.remove")}
                        </button>
                    )}
                </div>
            }
        >
            <ul className="w-full mt-[2vh] flex flex-col gap-[0.8vh]">
                {findings.map(({ doc, blankPages, remaining }) => (
                    <li key={doc.id} className="rounded-[1.6vh] bg-[#F1F3F7] px-[1.8vw] py-[1vh] text-[1.6vh] font-bold text-[#12161F] truncate">
                        {remaining.length
                            ? t("editDoc.blank_pages.doc_line", { name: doc.file_name, pages: formatPageList(blankPages) })
                            : t("editDoc.blank_pages.doc_line_all", { name: doc.file_name })}
                    </li>
                ))}
            </ul>
        </KioskModal>
    );
}

export default BlankPagesModal;
